import { Trans } from '@lingui/macro';
import { Link, View } from '@react-pdf/renderer';
import React from 'react';
import CloudinaryImage from '../../components/CloudinaryImage';
import QRCode from '../../components/QRCode';
import type { Collection, MyListPageItem } from './MyList';
import { Text } from './Text';

export default function Sidebar({
  exhibitor,
  collection,
}: {
  exhibitor: MyListPageItem;
  collection: Collection;
}) {
  return (
    <View
      style={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexShrink: 0,
        flexGrow: 0,
        width: 100,
        marginRight: 10,
        paddingBottom: 10,
      }}
    >
      {exhibitor?.logo?.fixed?.src && (
        <View style={{ marginTop: 10 }}>
          <CloudinaryImage
            src={exhibitor.logo.fixed.src}
            width={100}
            height={80}
            gravity="north"
            trim={true}
          />
        </View>
      )}
      <View style={{ flexGrow: 1 }} />
      <Link src={`${collection.site.publicUrl}/e/${exhibitor.exhibitorId}`}>
        <QRCode
          url={`${collection.site.publicUrl}/e/${exhibitor.exhibitorId}`}
          style={{ height: 50, width: 50, padding: 0, marginBottom: 3 }}
          margin={0}
        />
      </Link>
      <Text>
        <Trans>Scan to make notes</Trans>
      </Text>
    </View>
  );
}
